// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1CFzr","title":"ClientCherryInfo_title__LpJrR","itemText":"ClientCherryInfo_itemText__247bg"};